/* ── LIST/OF THEME JS ─────────────────────────────────────────── */

document.addEventListener('DOMContentLoaded', function () {

  // ── Pill nav scroll ──────────────────────────────────────────
  const nav = document.getElementById('lo-nav');
  if (nav) {
    let ticking = false;
    function updateNav() {
      nav.classList.toggle('light', window.scrollY > 80);
      ticking = false;
    }
    window.addEventListener('scroll', () => {
      if (!ticking) { requestAnimationFrame(updateNav); ticking = true; }
    }, { passive: true });
  }

  // ── Mobile burger menu ───────────────────────────────────────
  const burger = document.getElementById('lo-nav-burger');
  const drawer = document.getElementById('lo-nav-drawer');
  if (burger && drawer) {
    burger.addEventListener('click', () => {
      const isOpen = !drawer.classList.contains('open');
      drawer.classList.toggle('open', isOpen);
      burger.classList.toggle('open', isOpen);
      burger.setAttribute('aria-expanded', isOpen);
      document.body.style.overflow = isOpen ? 'hidden' : '';
    });
    drawer.querySelectorAll('a').forEach(a => a.addEventListener('click', () => {
      drawer.classList.remove('open');
      burger.classList.remove('open');
      burger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }));
  }

  // ── Research tabs ────────────────────────────────────────────
  window.switchTab = function (i) {
    document.querySelectorAll('.tab-btn').forEach((b, j) => {
      b.classList.toggle('active', j === i);
      b.setAttribute('aria-selected', j === i);
    });
    document.querySelectorAll('.tab-panel').forEach((p, j) => {
      p.classList.toggle('active', j === i);
    });
  };

  // ── Ingredient accordion ─────────────────────────────────────
  window.toggleIng = function (btn) {
    const row = btn.closest('.ing-row');
    const isOpen = row.classList.contains('open');
    document.querySelectorAll('.ing-row.open').forEach(el => {
      el.classList.remove('open');
      el.querySelector('.ing-row-trigger').setAttribute('aria-expanded', 'false');
    });
    if (!isOpen) { row.classList.add('open'); btn.setAttribute('aria-expanded', 'true'); }
  };

  // ── FAQ accordion ────────────────────────────────────────────
  window.toggleFAQ = function (btn) {
    const item = btn.closest('.lo-faq-item');
    const isOpen = item.classList.contains('open');
    document.querySelectorAll('.lo-faq-item.open').forEach(el => {
      el.classList.remove('open');
      el.querySelector('.faq-q').setAttribute('aria-expanded', 'false');
    });
    if (!isOpen) { item.classList.add('open'); btn.setAttribute('aria-expanded', 'true'); }
  };

  // ── Offer toggle (homepage) ───────────────────────────────────
  window.setOnce = function () {
    document.getElementById('lo-ob1')?.classList.add('active');
    document.getElementById('lo-ob2')?.classList.remove('active');
    const mp  = document.getElementById('lo-main-price');
    const ps  = document.getElementById('lo-per-serving');
    const op  = document.getElementById('lo-original-price');
    const tv  = document.getElementById('lo-total-val');
    const pl  = document.getElementById('lo-offer-plan');
    if (mp) mp.textContent = '$59';
    if (ps) ps.textContent = '$1.97 / serving';
    if (op) op.style.display = 'none';
    if (tv) tv.textContent = '$59';
    if (pl) pl.disabled = true;
  };

  window.setSubscribe = function () {
    document.getElementById('lo-ob2')?.classList.add('active');
    document.getElementById('lo-ob1')?.classList.remove('active');
    const mp  = document.getElementById('lo-main-price');
    const ps  = document.getElementById('lo-per-serving');
    const op  = document.getElementById('lo-original-price');
    const tv  = document.getElementById('lo-total-val');
    const pl  = document.getElementById('lo-offer-plan');
    if (mp) mp.textContent = '$49';
    if (ps) ps.textContent = '$1.63 / serving';
    if (op) op.style.display = '';
    if (tv) tv.textContent = '$49';
    if (pl) pl.disabled = false;
  };

  // ── PDP pricing tile select ───────────────────────────────────
  window.loPdpSelect = function (type) {
    const subTile  = document.getElementById('loPdpSubTile');
    const onceTile = document.getElementById('loPdpOnceTile');
    const planIn   = document.getElementById('lo-pdp-plan');
    const ctaBtn   = document.getElementById('lo-pdp-cta-btn');
    if (!subTile || !onceTile) return;
    if (type === 'sub') {
      subTile.classList.add('active');
      onceTile.classList.remove('active');
      if (planIn) planIn.disabled = false;
      if (ctaBtn) ctaBtn.textContent = 'Subscribe — $49/mo';
    } else {
      onceTile.classList.add('active');
      subTile.classList.remove('active');
      if (planIn) planIn.disabled = true;
      if (ctaBtn) ctaBtn.textContent = 'Buy Once — $59';
    }
  };

});
